function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("title", null, "noun_subscription_3147205");
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  id: "Desktop-view",
  stroke: "none",
  strokeWidth: 1,
  fill: "current"
}, /*#__PURE__*/React.createElement("g", {
  id: "Desktop-channel-view-Upgrade",
  transform: "translate(-815.000000, -336.000000)",
  fill: "current"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_subscription_3147205",
  transform: "translate(815.000000, 336.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M42,32.2 C45.7,32.2 48.7,35.2 48.7,38.9 C48.7,39.7 49.4,40.4 50.2,40.4 C51,40.4 51.7,39.7 51.7,38.9 C51.7,34.1 48.2,30.1 43.5,29.4 L43.5,20 C43.5,19.2 42.8,18.5 42,18.5 C41.2,18.5 40.5,19.2 40.5,20 L40.5,29.4 C35.9,30.1 32.3,34.1 32.3,38.9 C32.3,44.2 36.6,48.6 42,48.6 C45.7,48.6 48.7,51.6 48.7,55.3 C48.7,59 45.7,62 42,62 C38.3,62 35.3,59 35.3,55.3 C35.3,54.5 34.6,53.8 33.8,53.8 C33,53.8 32.3,54.5 32.3,55.3 C32.3,60.1 35.8,64.1 40.5,64.8 L40.5,74.2 C40.5,75 41.2,75.7 42,75.7 C42.8,75.7 43.5,75 43.5,74.2 L43.5,64.8 C48.1,64.1 51.7,60.1 51.7,55.3 C51.7,50 47.4,45.6 42,45.6 C38.3,45.6 35.3,42.6 35.3,38.9 C35.3,35.2 38.3,32.2 42,32.2 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M59.1,8.3 L55.9,10.3 C55.2,10.7 55,11.7 55.4,12.4 C55.7,12.9 56.2,13.1 56.7,13.1 C57,13.1 57.2,13 57.5,12.9 L64.9,8.3 C65.3,8 65.6,7.5 65.6,7 C65.6,6.5 65.3,6 64.9,5.7 L57,0.7 C56.3,0.3 55.4,0.5 54.9,1.2 C54.5,1.9 54.7,2.8 55.4,3.3 L58.6,5.3 L42,5.3 C18.8,5.3 0,24.2 0,47.3 C0,48.1 0.7,48.8 1.5,48.8 C2.3,48.8 3,48.1 3,47.3 C3,25.8 20.5,8.3 42,8.3 L59.1,8.3 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  fill: "current",
  d: "M82.5,45.2 C81.7,45.2 81,45.9 81,46.7 C81,68.2 63.5,85.7 42,85.7 L25.3,85.7 L28.5,83.7 C29.2,83.3 29.4,82.3 29,81.6 C28.6,80.9 27.6,80.7 26.9,81.1 L19.5,85.7 C19.1,86 18.8,86.5 18.8,87 C18.8,87.5 19.1,88 19.5,88.3 L27.4,93.3 C27.6,93.5 27.9,93.5 28.2,93.5 C28.7,93.5 29.2,93.3 29.5,92.8 C29.9,92.1 29.7,91.2 29,90.7 L25.8,88.7 L42,88.7 C65.2,88.7 84,69.8 84,46.7 C84,45.8 83.4,45.2 82.5,45.2 Z",
  id: "Path"
})))));
const SvgMoney = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "84px",
    height: "94px",
    viewBox: "0 0 84 94",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMoney, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/money.b123fb4d.svg";
export { ForwardRef as ReactComponent };